import { Injectable } from '@angular/core';
import type { IAutoAppliedCoupon } from '@app/interface/content/auto-applied-coupons.interface';
import { AutoApplyCouponType } from '@app/interface/content/auto-apply-coupon-type.enum';
import { AutoApplyCouponService } from '@app/service/shopping/coupon/auto-apply-coupon.service';

@Injectable({
  providedIn: 'root'
})
class CartRewardTrackerService {
  private enabled = false;
  private freeShippingMinCost: number = NaN;
  private freeCouponMinCost: number = NaN;
  private freeShippingEnabled = false;

  constructor(private autoApplyCouponService: AutoApplyCouponService) {}

  public setEnabled(value: boolean): void {
    this.enabled = value;
  }

  public isEnabled(): boolean {
    return this.enabled;
  }

  public setEnabledFreeShipping(value: boolean): void {
    this.freeShippingEnabled = value;
  }

  public isEnabledFreeShipping(): boolean {
    return this.freeShippingEnabled;
  }

  public setCouponPrice(freeShippingMinCost: number, freeCouponMinCost: number): void {
    this.freeShippingMinCost = freeShippingMinCost;
    this.freeCouponMinCost = freeCouponMinCost;
  }

  public getFreeShippingMinCost(): number {
    return this.freeShippingMinCost;
  }

  public getFreeCouponMinCost(): number {
    return this.freeCouponMinCost;
  }

  public getFreeShippingCoupon(): IAutoAppliedCoupon | undefined {
    return this.autoApplyCouponService.getCoupons().get(AutoApplyCouponType.FREE_SHIPPING);
  }

  public getFreeGiftCoupon(): IAutoAppliedCoupon | undefined {
    return this.autoApplyCouponService.getCoupons().get(AutoApplyCouponType.FREE_GIFT);
  }
}

export default CartRewardTrackerService;
